<template>
   <div  class="inside-bg">
    <div class="container" style="padding-top:100px">
      <h1>Colleges</h1>
    </div>
    <div class="container">
      <nav aria-label="breadcrumb" class="hc-breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item"><a href="/">Home</a></li>
          <li class="breadcrumb-item active" aria-current="page">Colleges</li>
        </ol>
      </nav>
      <div class="row responses-filter-row">
          <div class="col-lg-3 mb-lg-3">
              <v-autocomplete class="custom-autocomplete" v-model="filter.course_id" multiple @change="getColleges"  :items="courses" item-value="id" item-text="text"  small-chips outlined deletable-chips><template #label>Course</template></v-autocomplete>
          </div>
          <div class="col-lg-3 mb-lg-3">
              <v-autocomplete class="custom-autocomplete" v-model="filter.branch_id" multiple @change="getColleges"  :items="branches" item-value="id" item-text="text"  small-chips outlined deletable-chips><template #label>Branch</template></v-autocomplete>
          </div>
          <div class="col-lg-3 mb-lg-3">
              <v-autocomplete class="resp-filter"  v-model="filter.city_id" multiple @change="getColleges" :items="locations" item-value="id" item-text="text"  small-chips outlined deletable-chips><template #label>Location</template></v-autocomplete>
          </div>
    </div>
      <div class="" id="colleges" v-if="colleges.length !== 0 ">
        <div v-for="college in colleges" :key="college.college_id" class="card mb-2" @click="showCollegeDetails(college)">
          <div class="card-body">
            <div>{{college.college_name}}</div>
            <div><small><i class="mdi mdi-map-marker"></i>{{college.city_name}}</small></div>
            <div v-if="college.courses.length !== 0"><small><i class="mdi mdi-school"></i> {{ getInstiCourses(college.courses)}}</small></div>
          </div>
        </div>
      </div>
    </div>
   </div>
</template>

<script>
import Actions from '../libraries/apiActions.js';
import '../assets/hire.css';
import { mapState, mapGetters } from 'vuex';
import store from '../store';
import { COURSES } from '../store/modules/courses/constants';
import { BRANCHES } from '../store/modules/branches/constants';
import { STATES } from '../store/modules/states/constants';
export default {
    name:'Colleges',
    data: function(){
      return{
        colleges: [],
        action: new Actions(),
        filter: {
          course_id: null,
          city_id:null
        },
      }
    },
    beforeCreate() {
      this.$store = store;
  },
  created() {
    const apiFn = this.action;
    this.cachedDispatch(COURSES.GET_COURSE, { param: apiFn });
    this.cachedDispatch(STATES.GET_STATES, { param: apiFn });
    this.cachedDispatch(BRANCHES.GET_BRANCH, { param: apiFn });
  },
  computed: {
    ...mapGetters(['cachedDispatch']),
    ...mapState({
        courses: state => state.courses.courses.courses,
        locations: state => state.states.locations.locations,
        branches: state => state.branches.branches.branches,
    })
   },
    beforeMount(){
      this.getColleges();
    },
    methods: {
      getColleges: function(){
        this.action.getRegisteredColleges(this.filter).then(res => {
          if(res.status){
            this.colleges = res.institutes;
          }
        }).catch(err =>{
          console.log(err);
        })
      },
      getInstiCourses: function(courses){
        return courses.map(course => course.course_name).join(', ');
      },
      showCollegeDetails: function(college){
      let param = college.college_name.replace(/[^A-Z0-9]+/ig, "-");
      if(param.length > 80){
        param = param.substring(0, 80);
      }
       param = param+'-'+college.college_id;
       window.open(`/view-colleges/${param}`,'_blank');
      },
      getStates: async function () {
          await this.action.getStates().then(async (data) => {
          this.locations.push({header: 'Top Metropolitan Cities'})
          await data.states.forEach(async (element) => {
              await element.cities.forEach(city => {
                  if(city.top_city == 1){
                      this.locations.push({text:city.city_name,value:city.city_id, s_id:city.state_id,group:'Top Metropolitan Cities'})
                  }
              });
              this.locations.push({divider:true})
              this.locations.push({header: element.state_name});
              element.cities.forEach(city => {
                  if(city.top_city == 0){
                      this.locations.push({text:city.city_name,value:city.city_id, s_id:city.state_id,group:element.state_name})
                  }
              });
          });
      });
  },
    }
}
</script>
<style scoped>
  v-text-field__details{display: none !important;}
  .v-input__control fieldset {
    background-color: #fff !important; /* Your desired background color */
  }
#training-institutes .card {
  cursor: pointer;
 }
</style>